import { useContext } from 'react'
import { AuthContext as JwtContext } from '../contexts/JWTContext'
import { AuthContext as CognitoContext } from '../contexts/CognitoContext'
import { AuthMethod, CognitoContextType, JWTContextType } from '../types/auth'

export const useJwtAuth = () => {
  return useAuth('jwt') as JWTContextType
}

export const useCognitoAuth = () => {
  return useAuth('cognito') as CognitoContextType
}

const useAuth = (method?: AuthMethod) => {
  if (method === undefined) {
    method = (import.meta.env?.VITE_APP_AUTH_PROVIDER as AuthMethod) ?? 'jwt'
  }

  const context = method === 'cognito' ? useContext(CognitoContext) : useContext(JwtContext)

  if (!context) {
    throw new Error('AuthContext must be placed within AuthProvider')
  }

  return context
}

export default useAuth
